import { HttpClient } from "@angular/common/http";

import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import {
  MenuMasterCreateRequestDTO,
  MenuMasterDeleteRequestDTO,
  MenuMasterReadByIdRequestDTO,
  MenuMasterUpdateRequestDTO,
  RolesReadAllPaginatedRequestDTO,
  SubRoleCreateRequestDTO,
  SubRoleDeleteRequestDTO,
  SubRoleReadByRoleIdRequestDTO,
  SubRoleUpdateRequestDTO,
} from "./module-config-interface";

import {
  MenuMaster_create,
  MenuMaster_delete,
  MenuMaster_readAll,
  MenuMaster_readAllPaginated,
  MenuMaster_readById,
  MenuMaster_update,
  Roles_ReadAllPaginated,
  SubRoles_create,
  SubRoles_delete,
  SubRoles_readByRoleId,
  SubRoles_update,
} from "src/app/GlobalVariable";


@Injectable({
  providedIn: "root",
})
export class ModuleConfigService {

  constructor(
    private http: HttpClient,
  ) {}


  // ============================================================
  // MENU MASTER - READ ALL
  // EXISTING METHOD - KEEP FOR OLD WORKING CODE
  // ============================================================

  readAllMenus(): Observable<any> {

    return this.http.get<any>(
      MenuMaster_readAll,
    );
  }


  // ============================================================
  // MENU MASTER - READ ALL PAGINATED
  // NEW METHOD
  // ============================================================

  readAllMenusPaginated(
    request: {
      pageSize: number;
      pageNo: number;
      whereClause?: string | null;
      orderByClause?: string | null;
    },
  ): Observable<any> {

    return this.http.post<any>(
      MenuMaster_readAllPaginated,
      request,
    );
  }


  // ============================================================
  // MENU MASTER - READ BY ID
  // ============================================================

  readMenuById(
    request: MenuMasterReadByIdRequestDTO,
  ): Observable<any> {

    return this.http.post<any>(
      MenuMaster_readById,
      request,
    );
  }


  // ============================================================
  // MENU MASTER - CREATE
  // ============================================================

  createMenu(
    request: MenuMasterCreateRequestDTO,
  ): Observable<any> {

    return this.http.post<any>(
      MenuMaster_create,
      request,
    );
  }


  // ============================================================
  // MENU MASTER - UPDATE
  // ============================================================

  updateMenu(
    request: MenuMasterUpdateRequestDTO,
  ): Observable<any> {

    return this.http.post<any>(
      MenuMaster_update,
      request,
    );
  }


  // ============================================================
  // MENU MASTER - DELETE
  // ============================================================

  deleteMenu(
    request: MenuMasterDeleteRequestDTO,
  ): Observable<any> {

    return this.http.post<any>(
      MenuMaster_delete,
      request,
    );
  }


  // ============================================================
  // ROLES - READ ALL PAGINATED
  // ============================================================

  readAllRoles(
    request: RolesReadAllPaginatedRequestDTO,
  ): Observable<any> {

    return this.http.post<any>(
      Roles_ReadAllPaginated,
      request,
    );
  }


  // ============================================================
  // SUB ROLE - READ BY ROLE ID
  // ============================================================

  readSubRolesByRoleId(
    request: SubRoleReadByRoleIdRequestDTO,
  ): Observable<any> {

    return this.http.post<any>(
      SubRoles_readByRoleId,
      request,
    );
  }


  // ============================================================
  // SUB ROLE - CREATE
  // ============================================================

  createSubRole(
    request: SubRoleCreateRequestDTO,
  ): Observable<any> {

    return this.http.post<any>(
      SubRoles_create,
      request,
    );
  }


  // ============================================================
  // SUB ROLE - UPDATE
  // ============================================================

  updateSubRole(
    request: SubRoleUpdateRequestDTO,
  ): Observable<any> {

    return this.http.post<any>(
      SubRoles_update,
      request,
    );
  }


  // ============================================================
  // SUB ROLE - DELETE
  // ============================================================

  deleteSubRole(
    request: SubRoleDeleteRequestDTO,
  ): Observable<any> {

    return this.http.post<any>(
      SubRoles_delete,
      request,
    );
  }

}